import React from "react";
import {
  formatTruckSequenceChange,
  formatTruckSequenceStep,
  resolveTruckSequenceComparison,
} from "../utils/truckSequenceComparison.js";
import { joinClasses, pillToneClasses } from "./resultsPrimitives/shared.js";
import TruckOptimizationGanttComparison from "./TruckOptimizationGanttComparison.jsx";

export default function TruckSequenceComparison({ item }) {
  const comparison = resolveTruckSequenceComparison(item);
  if (!comparison) return null;
  const columns = comparison.status === "changed" ? (
    <div className="grid min-w-0 gap-2 md:grid-cols-2" data-truck-sequence-columns="true">
      {[["before", "Avant optimisation"], ["after", "Après optimisation"]].map(([side, title]) => (
        <div className="min-w-0 rounded-[4px] border border-slate-200 bg-slate-50/80 p-2" key={side} data-truck-sequence-side={side}>
          <h4 className="mb-1 text-xs font-bold text-slate-900">{title}</h4>
          <ol className="m-0 grid list-none gap-1 p-0" aria-label={title}>
            {comparison[side].map((row) => {
              const change = formatTruckSequenceChange(row, side);
              return (
                <li className={joinClasses([
                  "grid min-w-0 grid-cols-[1.5rem_minmax(0,1fr)] gap-x-1 rounded-[4px] px-1.5 py-1 text-xs leading-4",
                  change ? "bg-amber-soft text-slate-950" : "text-slate-600",
                ])} key={row.position} data-truck-sequence-change={row.change}>
                  <span className="font-semibold" aria-hidden="true">{row.position}.</span>
                  <div className="min-w-0 [overflow-wrap:anywhere]">
                    <span>{formatTruckSequenceStep(row)}</span>
                    {row.is_preloaded_previous_day ? <span className="ml-1 text-slate-500">· Chargé la veille</span> : null}
                    {change ? <span className="block font-semibold">{change}</span> : null}
                  </div>
                </li>
              );
            })}
          </ol>
          {!comparison[side].length ? <p className="m-0 text-xs text-slate-500">Aucune étape</p> : null}
        </div>
      ))}
    </div>
  ) : null;
  return (
    <section className="grid min-w-0 gap-1.5" aria-label="Ordre des chargements et livraisons" data-truck-sequence-comparison={comparison.status}>
      <span className={joinClasses([
        "justify-self-start rounded-[4px] px-2 py-0.5 text-xs font-semibold",
        comparison.status === "changed" ? pillToneClasses.info : pillToneClasses.neutral,
      ])} data-truck-sequence-status="true">
        {comparison.label}
      </span>
      {/* Captures without a Gantt photo, or whose photo is unavailable, keep the text sequence. */}
      {columns && comparison.gantt_capture_id ? (
        <TruckOptimizationGanttComparison captureId={comparison.gantt_capture_id} dispatchDate={item.dispatchDate}
          dispatchPeriod={item.dispatchPeriod} fallback={columns} />
      ) : columns}
    </section>
  );
}
